/**
 * Normalizes restaurantId to ensure it's always a string
 * Handles cases where restaurantId might be:
 * - A string (already correct)
 * - An object with _id property
 * - An object with id property
 * - null/undefined
 */
export const normalizeRestaurantId = (restaurantId) => {
    if (!restaurantId) return null;
    
    if (typeof restaurantId === 'string') {
        return restaurantId;
    }
    
    if (typeof restaurantId === 'object') {
        return restaurantId._id || restaurantId.id || null;
    }
    
    return String(restaurantId);
};

